import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import useChatDispatchActions from '../../../customHooks/useChatDispatchActions';
import { APPLY_INTERNAL_CHAT_GROUP_UPDATE } from '../../../helpers/internalChatConstants';

/** Aplica ao estado o grupo devolvido por uma ação de gestão: grupo excluído, ou do
 *  qual o usuário logado saiu, some da lista; senão é atualizado pelo id.
 */
function useApplyGroupUpdate() {
    const dispatchChatActions = useChatDispatchActions();
    const loggedUserId = useSelector(state => state.auth.userData?.id);

    return useCallback((group) => {
        if (!group) return;
        dispatchChatActions(APPLY_INTERNAL_CHAT_GROUP_UPDATE, { group, loggedUserId });
    }, [dispatchChatActions, loggedUserId]);
}

export default useApplyGroupUpdate;
